import { useRef, useState } from 'react';

export const useCalendarOverflowSpace = () => {
  const contentEndRef = useRef<HTMLDivElement>(null);
  const [calendarSpace, setCalendarSpace] = useState(0);

  const handleCalendarBottomChange = (calendarBottom: number | null) => {
    const contentEnd = contentEndRef.current?.getBoundingClientRect().top;

    if (calendarBottom === null || contentEnd === undefined) {
      setCalendarSpace(0);
      return;
    }

    setCalendarSpace(Math.max(0, calendarBottom - contentEnd));
  };

  return { contentEndRef, calendarSpace, handleCalendarBottomChange };
};
